import { useSuspenseQuery } from '@apollo/client';
import {
  MissionListPage,
  MissionListPageQuery,
  MissionListPageQueryVariables,
  FETCH_MISSION_LIST_PAGE,
} from '@edwin-group/cj-graphql';
import { useMissionListingStore } from '../store/useMissionListingStore';
import { useEffect, useState } from 'react';
import { TabsListingEnum } from '../../shared/components/tabs-listing';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useRoot = () => {
  const setMissionListPage = useMissionListingStore((state) => state.setMissionListPage);
  const updateFilters = useMissionListingStore((state) => state.updateFilters);
  const [currentTab, setCurrentTab] = useState<TabsListingEnum>(TabsListingEnum.MISSIONS);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const programmeName = searchParams.get('programmeName');
  const missionsDocumentIds = searchParams.get('missionsDocumentIds');

  const { data: missionListPageResult, error: missionListPageError } = useSuspenseQuery<
    MissionListPageQuery,
    MissionListPageQueryVariables
  >(FETCH_MISSION_LIST_PAGE, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (location.pathname.includes('programmes')) {
      setCurrentTab(TabsListingEnum.PROGRAMMES);
      return;
    }

    if (programmeName && missionsDocumentIds) {
      updateFilters({
        missionsDocumentIds: missionsDocumentIds.split(','),
      });
      setCurrentTab(TabsListingEnum.MISSIONS);
      return;
    }

    updateFilters({
      missionsDocumentIds: [],
    });
  }, [location.pathname, programmeName, missionsDocumentIds, updateFilters]);

  useEffect(() => {
    if (missionListPageResult) {
      setMissionListPage(missionListPageResult?.missionListPage as MissionListPage);
    }
  }, [missionListPageResult, setMissionListPage]);

  return {
    currentTab,
    errors: [missionListPageError].filter(Boolean),
    setCurrentTab,
  };
};
